/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_ValueInputs */

const vi_report_inventory_value = /** @type {(inputs: Report_Inventory_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá trị`)
};

/**

* @param {Report_Inventory_ValueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_value = /** @type {((inputs?: Report_Inventory_ValueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_ValueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_value(inputs)
});